module.exports = __webpack_public_path__ + "static/img/h15.11e228c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h15.jpg
// module id = CRBz
// module chunks = 0